import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container py-5">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <h5 className="footer-logo">
              YOLA <i className="fa fa-heart text-danger ms-1"></i>
            </h5>
            <p>
              Don't waste your time. Grab your favourites! Yola is here to bring physical
              goods, services, and digital products right to your door.
            </p>
            <div className="social-icons">
              <NavLink to="#">
                <i className="fa fa-instagram"></i>
              </NavLink>
              <NavLink to="#">
                <i className="fa fa-facebook"></i>
              </NavLink>
              <NavLink to="#">
                <i className="fa fa-google"></i>
              </NavLink>
              <NavLink to="#">
                <i className="fa fa-twitter"></i>
              </NavLink>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 footer-links">
            <h5>Links</h5>
            <ul className="list-unstyled">
              <li>
                <NavLink to="#">Home</NavLink>
              </li>
              <li>
                <NavLink to="#">Features</NavLink>
              </li>
              <li>
                <NavLink to="#">Pricing</NavLink>
              </li>
              <li>
                <NavLink to="#">FAQs</NavLink>
              </li>
              <li>
                <NavLink to="#">About</NavLink>
              </li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h5>Newsletter</h5>
            <p>Stay updated with our latest offers and news.</p>
            <div className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
              />
              <button className="newsletter-btn">
                <i className="fa fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Yola. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
